/*
 * vt-holiday-title.js
 * Shared "brain" for the VT countdown-header auto holiday title.
 *
 * Used by both vt-countdown-header.liquid (James / vt-pdp) and
 * vt-countdown-header-castor.liquid (Castor). Each countdown title element
 * opts in with: data-vt-holiday-title  data-vt-holiday-tz="America/New_York".
 *
 * What it does, on every page load (and theme-editor section reload):
 *   1. Reads "today" in a fixed US timezone (DST handled automatically by Intl).
 *   2. Computes each US retail holiday for the current year FROM RULES
 *      (e.g. Thanksgiving = 4th Thursday of Nov; Black Friday = +1; Cyber Monday = +4).
 *      Nothing is hard-keyed per year, so it self-updates forever.
 *   3. Picks the nearest active sale window and overwrites the title text.
 *      If no holiday is active, it leaves the Liquid fallback title untouched
 *      (so the banner is never blank, and works even if this script fails).
 *
 * To add a new sale moment: add one line to holidaysFor(). That is the only
 * maintenance this ever needs.
 */
(function () {
  if (window.__vtHolidayTitle) return; // load-once guard (both sections include this file)
  window.__vtHolidayTitle = true;

  // --- date rule helpers (month is 0-indexed: Jan=0 ... Dec=11) ---
  function nthWeekdayDay(y, month, weekday, n) {
    // weekday: 0=Sun ... 6=Sat. Returns the day-of-month of the nth weekday.
    var first = new Date(y, month, 1).getDay();
    return 1 + ((weekday - first + 7) % 7) + (n - 1) * 7;
  }
  function lastWeekdayDay(y, month, weekday) {
    var last = new Date(y, month + 1, 0); // last calendar day of the month
    return last.getDate() - ((last.getDay() - weekday + 7) % 7);
  }
  function D(y, month, day) { return new Date(y, month, day); }

  // All in-scope US retail moments for a given year, as {name, lead, date}.
  // `lead` = how many days BEFORE the date the sale title starts showing.
  function holidaysFor(y) {
    var thanksgiving = D(y, 10, nthWeekdayDay(y, 10, 4, 4)); // 4th Thursday of November
    var blackFriday = new Date(thanksgiving); blackFriday.setDate(thanksgiving.getDate() + 1);
    var cyberMonday = new Date(thanksgiving); cyberMonday.setDate(thanksgiving.getDate() + 4);
    return [
      { name: 'New Year',        lead: 7,  date: D(y, 0, 1) },
      { name: "Valentine's Day", lead: 7,  date: D(y, 1, 14) },
      { name: "Mother's Day",    lead: 7,  date: D(y, 4, nthWeekdayDay(y, 4, 0, 2)) },  // 2nd Sun May
      { name: 'Memorial Day',    lead: 4,  date: D(y, 4, lastWeekdayDay(y, 4, 1)) },     // last Mon May
      { name: "Father's Day",    lead: 7,  date: D(y, 5, nthWeekdayDay(y, 5, 0, 3)) },   // 3rd Sun Jun
      { name: '4th of July',     lead: 7,  date: D(y, 6, 4) },
      { name: 'Labor Day',       lead: 4,  date: D(y, 8, nthWeekdayDay(y, 8, 1, 1)) },   // 1st Mon Sep
      { name: 'Halloween',       lead: 7,  date: D(y, 9, 31) },
      { name: 'Black Friday',    lead: 5,  date: blackFriday },
      { name: 'Cyber Monday',    lead: 3,  date: cyberMonday },
      { name: 'Christmas',       lead: 10, date: D(y, 11, 25) }
    ];
  }

  // "Today" as a local-midnight Date marker, but using a fixed US timezone's calendar date.
  function usToday(tz) {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: tz || 'America/New_York',
      year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return D(+o.year, +o.month - 1, +o.day);
  }

  // Returns the sale title string for the given timezone, or null if no holiday is active.
  function labelFor(tz) {
    var today = usToday(tz);
    var y = today.getFullYear();
    var list = holidaysFor(y).concat(holidaysFor(y + 1)); // include next year so late-Dec sees New Year
    var best = null;
    for (var i = 0; i < list.length; i++) {
      var diff = Math.round((list[i].date - today) / 86400000); // whole days until the holiday
      if (diff < 0 || diff > list[i].lead) continue;            // not in this holiday's window
      if (best === null || diff < best.diff) {                  // nearest upcoming wins (0 = today)
        best = { diff: diff, name: list[i].name };
      }
    }
    if (!best) return null;
    return best.name + ' Sale' + (best.diff === 0 ? ' - Ends Today' : '');
  }

  function apply() {
    var els = document.querySelectorAll('[data-vt-holiday-title]');
    for (var i = 0; i < els.length; i++) {
      try {
        var tz = els[i].getAttribute('data-vt-holiday-tz') || 'America/New_York';
        var label = labelFor(tz);
        if (label) {
          var target = els[i].querySelector('strong') || els[i];
          target.textContent = label;
        }
      } catch (e) { /* leave the Liquid fallback title in place */ }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  // Re-run when a merchant edits the section in the theme customizer.
  document.addEventListener('shopify:section:load', apply);
})();
